import { StateProvider } from "contexts/ContextProvider";
import { Route, Routes } from "react-router-dom";
import BranchCreateScreen from "screens/App/CRM/Branch/BranchCreateScreen";
import BranchDetailScreen from "screens/App/CRM/Branch/BranchDetailScreen";
import BranchEditScreen from "screens/App/CRM/Branch/BranchEditScreen";
import BranchListScreen from "screens/App/CRM/Branch/BranchListScreen";
import NotFoundScreen from "screens/NotFoundScreen";

const BranchRouter = () => {
  return (
    <StateProvider>
      <Routes>
        <Route path="create" element={<BranchCreateScreen />} />
        <Route path=":id/detail" element={<BranchDetailScreen />} />
        <Route path=":id/edit" element={<BranchEditScreen />} />
        <Route path="list" element={<BranchListScreen />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </StateProvider>
  );
};

export default BranchRouter;
